// Avisa o Sentry quando o login é aceito e o app não pede meus-dados em seguida. Esse travamento não
// lança exceção, então sem o aviso não deixa rastro.
import * as Sentry from '@sentry/react';

export const PRAZO_MEUS_DADOS_MS = 5000;

let temporizador = null;

export function vigiaMeusDados(origem, getState) {
    Sentry.addBreadcrumb({ category: 'auth.login', message: 'Login aceito', data: { origem } });
    clearTimeout(temporizador);
    temporizador = setTimeout(() => {
        temporizador = null;
        const { eventoState, userState } = getState();
        const evento = eventoState.evento.item;
        Sentry.captureMessage('Login sem meus-dados em 5s', {
            level: 'warning',
            tags: {
                eventoId: evento.id,
                tipoAutenticacaoId: evento.tipoAutenticacaoId,
                rota: window.location.pathname,
                origem,
                temEventoId: Boolean(evento.id),
                temToken: Boolean(userState.user?.token)
            }
        });
    }, PRAZO_MEUS_DADOS_MS);
}

export function meusDadosPedido() {
    clearTimeout(temporizador);
    temporizador = null;
}
